<template>
<div>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-clear-style-wrap"
    custom-class="dialog-clear-style"
    :show-close="false"
    :modal="false"
    top="0"
    append-to-body
  >
    <div class="scroll-wrap" @scroll="detailScroll" @click="showDialog = false">
      <fps-icon class="close-skill-detail pointer" type="close" size="24" color="#fff" @click.native.stop="$emit('change', false)" />
      <div v-if="!isSelf && !masterDialog && !quickMatchUuid" class="skill-slide" @click.stop>
        <!-- 右侧dialog外边顶部头像 -->
        <fps-avatar
          class="user-image pointer"
          :src="skillInfo.avatarImageUrl"
          :level="skillInfo.userLevel"
          @click.native="openMasterDetail()"
        />
        <div class="im-icon pointer" @click="openChat">
          <fps-icon type="message" size="18" color="#fff" />
        </div>
        <div class="im-icon pointer" @click="showShareDialog = true">
          <fps-icon type="share" size="18" color="#fff" />
        </div>
      </div>
      <div v-show="showBackTop" class="back-top" @click.stop="backTop">
        <fps-icon type="back-to-top" size="24" color="#fff" />
      </div>
      <div
        class="order-bottom"
        :style="{
          transform: showBottomOrder && !quickMatchUuid && !isSelf ? 'translate(-50%, 0)' : 'translate(-50%, 100%)'
        }"
        @click.stop
      >
        <div class="price-wrap">
          <span class="sale-price">{{ selectedModel.showPrice }}</span>
          <span class="sale-price">幣</span>
          <span class="sale-unit">/{{ selectedModel.salesUnit | salesUnitTranslate  }}</span>
          <span v-if="selectedModel.showPrice !== selectedModel.price" class="old-price">{{ selectedModel.price }}幣/{{ selectedModel.salesUnit | salesUnitTranslate  }}</span>
        </div>
        <div class="tool-buttons">
          <button class="chat-btn" @click="openChat">
            <fps-icon type="message" size="18" />
            <span class="chat-btn-text">聊一聊</span>
          </button>
          <button class="order-btn" @click="openOrderPage">
            立即下單
          </button>
        </div>
      </div>
      <div class="skill-detail-dialog" @click.stop>
        <div ref="page_top" class="page-top" />
        <div v-if="!masterDialog" class="skill-detail-title">
          <!-- dialog顶部左上角头像 -->
          <fps-avatar
            class="user-image"
            :class="!quickMatchUuid && 'pointer'"
            :src="skillInfo.avatarImageUrl"
            :level="skillInfo.userLevel"
            @click.native="openMasterDetail()"
          />
          <span class="nickname" :class="!quickMatchUuid && 'pointer'" @click="openMasterDetail()">{{ skillInfo.nickname }}</span>
          <fps-icon v-if="isAdmin" class="is-admin" type="v-mark" size="22" color="#FFA24E" />
          <div v-else class="userlevel-tag" :class="`level-${skillInfo.userLevel}`"></div>
          <div v-if="isOnline" class="online-circle-wrap" :class="isOnline && 'is-online-wrap'"/>
          <span class="online-text">{{ isOnline ? '可接單' : '5分鐘前在線上' }}</span>
          <!-- <span class="reply-count">及時回覆率%</span> -->
        </div>
        <div class="skill-top">
          <img v-if="masterDialog" class="game-image" :src="skillInfo.gameImageUrl + '?d=300x300'" >
          <PhotoList
            v-else
            class="photo-list"
            :width="304"
            :isLoading="loadingViewMasterInfo"
            :masterInfo="viewMasterInfo"
            :photoList="[skillInfo.avatarImageUrl]"
          />
          <div class="skill-info">
            <div class="skill-name">{{ skillInfo.gameName }}</div>
            <div class="order-state">
              <div class="order-count">接單<span class="stronger">{{ skillInfo.countTransactions }}</span>次</div>
              <div class="line" />
              <fps-star
                :count="skillInfo.starRating"
                :size="12"
              />
              <span v-if="skillInfo.starRating" class="order-score">
                {{ skillInfo.starRating | parseNum(1) }}
                <span v-if="skillInfo.countComment">({{ skillInfo.countComment }})</span>
              </span>
            </div>
            <div class="display-price">
              <div class="price">
                <span class="sale-price">{{ selectedModel.showPrice }}</span>
                <span class="sale-price">幣</span>
                <span class="sale-unit">/{{ selectedModel.salesUnit | salesUnitTranslate  }}</span>
                <span v-if="selectedModel.showPrice !== selectedModel.price" class="old-price">{{ selectedModel.price }}幣/{{ selectedModel.salesUnit | salesUnitTranslate  }}</span>
              </div>
              <div
                v-if="skillInfo.redBagFreeFlag && selectedModel.showPrice === 1"
                class="price-onecoin"
              >
                <div><span>1幣限購</span>銅板價，高CP值</div>
              </div>
              <div v-else class="discount-list">
                <div
                  v-for="(d,i) in discountList"
                  :key="`discount-${i}`"
                  class="one-discount"
                >{{ d }}</div>
              </div>
            </div>
            <div class="discount-price" />
            <template v-if="skillInfo.skillPriceList && skillInfo.skillPriceList.length">
              <div class="select-wrap select-price">
                <div class="select-left">計費模式</div>
                <div class="select-right">
                  <div class="model-price" :class="!selectedModel.id && 'selected'" @click="selectPrice()">
                    <span class="model-name">標準模式</span>
                    <span class="price">{{ skillInfo.salesPrice }}幣/{{ skillInfo.salesUnit | salesUnitTranslate }}</span>
                  </div>
                    <div
                      v-for="(p, i) in skillInfo.skillPriceList"
                      :key="'price' + (i + 1)"
                      class="model-price"
                      :class="selectedModel.id === p.id && 'selected'"
                      @click="selectPrice(p)"
                    >
                      <span class="model-name">{{ p.name }}</span>
                      <span class="price">{{ p.price }}幣/{{ p.salesUnit | salesUnitTranslate }}</span>
                    </div>
                </div>
              </div>
            </template>
            <div v-if="!isSelf" class="select-wrap select-count">
              <div class="select-left">數量</div>
              <div class="select-right">
                <InputNumber
                  v-model="orderCount"
                  :disabled="!!quickMatchUuid"
                  :max="15"
                />
              </div>
            </div>
            <div v-if="skillInfo.giveAwayList && skillInfo.giveAwayList.length && !newComerCouponList[0]" class="select-wrap give-away">
              <div class="select-left">滿贈優惠</div>
              <div class="select-right">
                <div
                  v-for="(g, i) in skillInfo.giveAwayList"
                  :key="`give-away${i}`"
                  class="one-give-away"
                >{{ `滿${ g.startNum }贈${ g.giftNum }` }}</div>
              </div>
            </div>
            <div v-if="!isSelf && !quickMatchUuid && !loadingViewMasterInfo" ref="tool_button_bottom" class="tool-buttons">
              <button class="chat-btn" @click="openChat">
                <fps-icon type="message" size="18" />
                <span class="chat-btn-text">聊一聊</span>
              </button>
              <button class="order-btn" @click="openOrderPage">
                立即下單
              </button>
            </div>
          </div>
        </div>
        <div class="skill-description">
          <div class="detail-title">技能介紹</div>
          <fps-voice
            class="skill-voice"
            :src="skillInfo.voiceUrl"
            :color="skillInfo.sex === 'Female' ? '#EC5375' : '#5362EC'"
            :control="true"
          />
          <LineControl class="desc-context" v-if="skillInfo.description" :rows="8">
            <el-input
              v-model="skillInfo.description"
              type="textarea"
              class="wrap-text"
              autosize
              resize="none"
              disabled
            />
          </LineControl>
          <div v-if="labelList.length" class="skill-description-tags">
            <div class="tags-list">
              <div
                v-for="(l, i) in labelList"
                :key="'label-' + (l.labelId || i)"
                :class="l.classes"
              >{{ l.onlyShowIamge?'':l.name }}</div>
            </div>
            <TipBtn
              width="280"
            >
              <div class="label-text">
                <div class="title">
                  標籤說明
                </div>
                <ul>
                  <li>
                    <div class="custom-tag rebought tag-wrap">回單王</div><span>人均回購單數排名TOP20（近90天）</span>
                  </li>
                  <li>
                    <div class="custom-tag nice tag-wrap">夯口碑</div><span>近期該技能精選評價表現優異</span>
                  </li>
                  <li>
                    <div class="custom-tag hot tag-wrap">高人氣</div><span>近期該技能完成單量表現優異</span>
                  </li>
                  <li v-if="c.tags && c.tags.some(v=>v.tag=='小萌新')">
                    <div class="custom-tag new tag-wrap">小萌新</div><span>近期入駐的優質陪玩師</span>
                  </li>
                  <li v-if="showLolTag">
                    <div class="comment-tag top tag-wrap">位置認證</div><span>此位置表現優異</span>
                  </li>
                </ul>
              </div>
            </TipBtn>
          </div>
          <div class="line" />
          <div v-if="skillInfo.gameLevelString" class="skill-attr">
            <div class="skill-attr-name">段位</div>
            <div class="skill-attr-value">{{ skillInfo.gameLevelString }}</div>
          </div>
          <template v-if="skillInfo.gamePropertyMap">
            <div
              v-for="(v, a) in skillInfo.gamePropertyMap"
              :key="`skill-attr${a}`"
              class="skill-attr"
            >
              <div class="skill-attr-name">{{ v.propertyName }}</div>
              <div class="skill-attr-value">{{ v.propertyValueList.join(' ') }}</div>
            </div>
          </template>
          <div v-if="screenshotImageUrlList.length" class="custom-swiper custom-swiper-banner">
            <el-carousel
              ref="banner"
              class="banner-logined"
              height="423px"
              :autoplay="false"
              trigger="click"
              arrow="never"
              :loop="false"
              :indicator-position="screenshotImageUrlList.length > 1 ? '' : 'none'"
              @change="changeSwipe"
            >
              <el-carousel-item
                v-for="(item, i) in screenshotImageUrlList"
                :key="skillInfo.id + '-image' + i"
              >
                <fps-scale-img
                  :src="item + '?d=686x340'"
                  :imageList="screenshotImageUrlList"
                  :defaultIndex="i"
                  borderRadius="4px"
                />
              </el-carousel-item>
            </el-carousel>
            <div v-show="swipeIndex !== 0" class="custom-arrow custom-arrow-left" @click="swipeChange('prev', 'banner')">
              <fps-icon type="arrow-left" size="24" />
            </div>
            <div v-show="swipeIndex < screenshotImageUrlList.length - 1" class="custom-arrow custom-arrow-right" @click="swipeChange('next', 'banner')">
              <fps-icon type="arrow-right" size="24" />
            </div>
          </div>
          <div v-if="skillInfo.certificationExtraData && skillInfo.certificationExtraData.kda !== null && skillInfo.certificationExtraData.kda !== undefined" class="pubg-kda">
            <img class="nicee-certification" src="~@/assets/image/icons/shield-blue.png">
            <span>{{ skillInfo.certificationExtraData.gameMode | parseGameMode }}</span>
            <span>{{ skillInfo.certificationExtraData.roundsPlayed }}場</span>
            <span>KDA{{ skillInfo.certificationExtraData.kda }}</span>
          </div>
        </div>
        <div v-if="!isSelf && !quickMatchUuid" class="master-info">
          <div class="detail-title">關於陪玩師</div>
          <div class="master-info-wrap">
            <div class="master-info-wrap-left">
              <div class="user-avatar">
                <!-- 关于陪玩师，个人资料卡片 -->
                <fps-avatar
                  class="pointer"
                  :src="skillInfo.avatarImageUrl"
                  :level="skillInfo.userLevel"
                   :style="{ transform: `scale(${skillInfo.userLevel > 5 ? 0.7 : 1 })` }"
                  @click.native="openMasterDetail()"
                />
                <div v-if="isOnline" class="online-state" :class="isOnline && 'is-online-wrap'" />
              </div>
              <div class="master-info-wrap-left-other">
                <div class="user-nickname pointer" @click="openMasterDetail()">{{ skillInfo.nickname }}</div>
                <div class="tool-btns">
                  <button class="chat-btn" @click="openChat">
                    <fps-icon type="message" size="12" />
                    <span class="chat-btn-text">聊一聊</span>
                  </button>
                  <button class="detail-btn" @click="openMasterDetail()">
                    查看主頁
                  </button>
                </div>
              </div>
            </div>
            <div class="line" />
            <div v-if="loadingViewMasterInfo" class="master-info-wrap-right loading-wrap">
              <div class="data-wrap-name">
                <div>評分</div>
                <div>接單次數</div>
              </div>
              <div class="data-wrap-value">
                <div>--</div>
                <div>--</div>
              </div>
              <div class="data-wrap-name">
                <div>
                  <span>綜合評分</span>
                  <fps-icon type="question" size="18" color="rgba(99, 109, 134, 0.5)" />
                </div>
                <div>粉絲</div>
              </div>
              <div class="data-wrap-value">
                <div>--</div>
                <div>--</div>
              </div>
            </div>
            <div v-else class="master-info-wrap-right">
              <div class="data-wrap-name">
                <div>評分</div>
                <div>接單次數</div>
              </div>
              <div class="data-wrap-value">
                <div>{{ (userOrder.star ? userOrder.star / userOrder.starOrder : userOrder.star) | parseNum(1) }}({{ userOrder.starOrder }})</div>
                <div>{{ userOrder.order }}</div>
              </div>
              <div class="data-wrap-name">
                <div class="score-btn" @click="openScorePopup">
                  <span>綜合評分</span>
                  <fps-icon type="question" size="18" color="rgba(99, 109, 134, 0.5)" />
                </div>
                <div>{{ viewMasterInfo.follower ? '粉絲' : ' '}}</div>
              </div>
              <div class="data-wrap-value">
                <div>{{ viewMasterInfo.playerScore | parseNum }}</div>
                <div>{{ viewMasterInfo.follower || ' ' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="comment-list">
          <div class="detail-title">
            <span>評分及評價<span v-show="commentTotal"> ({{ commentTotal }})</span></span>
            <div class="star-count">
              <span>{{ (skillInfo.starRating || '') | parseNum(1) }}</span>
              <fps-star :count="skillInfo.starRating" :size="12" />
            </div>
          </div>
          <div v-if="gettingComment && (!commentCateList || !commentCateList.length)" class="loading-container">
            <i class="el-icon-loading"></i>
          </div>
          <div v-if="commentCateList && commentCateList.length" class="comment-cate">
            <div
              v-for="c in commentCateList"
              :key="`comment-cate-${c.id}`"
              class="one-comment-cate"
              :class="c.id === selectedCommentCateId && 'selected'"
            >{{ c.tag }}<span class="count">({{ c.count }})</span></div>
          </div>
          <div v-if="commentList.length" class="comment-list-wrap">
            <div
              v-for="(c, i) in commentList"
              :key="'comment-' + i"
              class="one-comment"
            >
              <!-- 评论列表的头像 -->
              <fps-avatar
                class="comment-avatar"
                :src="c.commentatorAvatarUrl"
                :guard-type="borderMethod(c.giftRankOrder)"
                :level="c.commentatorUserLevel"
                :class="!c.anonymous && 'pointer'"
                :style="{ transform: `scale(${c.commentatorUserLevel > 5 ? 0.8 : 1})` }"
                @click.native="!c.anonymous && openMasterDetail(c.commentatorUuid)"
              />
              <div class="info-wrap">
                <div class="nickname pointer" @click="openMasterDetail(c.commentatorUuid)">
                  <span>{{ c.commentatorName }}</span>
                  <fps-icon v-if="c.commentatorUuid == adminUuid" type="v-mark" class="is-admin" size="18" color="#FFA24E" />
                  <div v-else class="userlevel-tag" :class="`level-${c.commentatorUserLevel}`"></div>
                </div>
                <div class="comment-time">{{ new Date(c.createTime).$format('yyyy-MM-dd') }}</div>
                <div class="comment-content">
                  <img v-if="c.recommendStatus === 'Recommend'" class="good-comment" src="~@/assets/image/icons/comment-good.png">
                  {{ c.content }}
                </div>
                <div v-if="c.tags && c.tags.length" class="tags-list-wrap">
                  <fps-icon type="tag" size="10" />
                  {{ c.tags.map(tag => tag.tag).join('，') }}
                </div>
                <div v-if="isSelf && c.reply.status === 'CanReply' && !c.replying" class="reply-btn" @click="editReply(i)">
                  <fps-icon type="reply" size="10" />
                  回覆
                </div>
                <div v-else-if="isSelf && c.reply.status === 'CanReply' && c.replying" class="replying-wrap">
                  <div class="master-reply">
                    <span class="nickname">{{ viewMasterInfo.nickname }}</span>
                    <span>回覆：</span>
                  </div>
                  <textarea v-model="c.replyContent" class="reply-content" placeholder="請輸入回覆內容" />
                  <div class="reply-btns">
                    <button class="cancel-btn" @click="cancelReply">取消</button>
                    <button class="confirm-btn" :disabled="!c.replyContent" @click="finshReply">
                      <i v-if="c.replyLoading" class="el-icon-loading"></i>
                      <span v-else>完成</span>
                    </button>
                  </div>
                </div>
                <div v-if="c.reply.status == 'HadReply' && c.reply.content" class="replying-wrap">
                  <div class="master-reply">
                    <span class="nickname">{{ viewMasterInfo.nickname }}</span>
                    <span>回覆：</span>
                  </div>
                  <div class="replyed-content">{{ c.reply.content }}</div>
                </div>
              </div>
              <fps-star class="comment-star" :count="c.starRating" :size="10" />
            </div>
            <div v-if="commentFinshed" class="no-more-comment">沒有更多了</div>
            <div v-else-if="gettingComment" class="get-more-comment">
              <i class="el-icon-loading"></i>
            </div>
            <div v-else class="get-more-comment pointer" @click="getCommentList">
              <span>查看更多</span>
            </div>
          </div>
          <div v-else-if="!gettingComment" class="comment-empty">
            <img class="comment-empty-img" src="~@/assets/image/background/empty-comment.png">
            <span class="comment-empty-text">目前還沒有任何評價喔～</span>
          </div>
        </div>
        <div v-if="!masterDialog && !quickMatchUuid && viewMasterInfo.playerSkillVoList && viewMasterInfo.playerSkillVoList.length > 1" class="other-skill">
          <div class="detail-title"><span v-if="!isSelf">他的</span>其他技能</div>
          <div v-if="loadingViewMasterInfo" class="loading-container">
            <i class="el-icon-loading"></i>
          </div>
          <div v-if="rankListActive" class="custom-swiper">
            <el-carousel
              ref="ranks"
              class="ranks-slide"
              height="190px"
              :interval="0"
              trigger="click"
              arrow="never"
              indicator-position="none"
              :loop="false"
              @change="rankSlideIndex = $event"
            >
              <el-carousel-item
                v-for="(list, index) in rankListActive"
                :key="index"
                class="ranks-slide-card"
              >
                <div
                  v-for="(item, i) in list"
                  :key="item ? item.id : i"
                  class="one-game"
                >
                  <div v-if="item" class="pointer" @click="changeSkill(item)">
                    <img class="game-image" :src="item.gameImageUrl + '?d=300x300'">
                    <span class="game-name">{{ item.gameName }}</span>
                    <span class="sale-price">{{ item.salesPrice }}幣 /{{ item.salesUnit | salesUnitTranslate }}</span>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div
              v-show="rankSlideIndex !== 0"
              class="custom-arrow custom-arrow-left visible-arrow"
              @click="swipeChange('prev', 'ranks')"
            >
              <fps-icon type="arrow-left" size="24" />
            </div>
            <div
              v-show="rankSlideIndex !== rankListActive.length - 1"
              class="custom-arrow custom-arrow-right visible-arrow"
              @click="swipeChange('next', 'ranks')"
            >
              <fps-icon type="arrow-right" size="24" />
            </div>
          </div>
        </div>
        <ScoreExplain
          v-model="scorePopupStatus"
          :popupType="scorePopupType"
          :score="viewMasterInfo.playerScore || 0"
          :isGood="viewMasterInfo && viewMasterInfo.alertScore"
        />
      </div>
    </div>
  </el-dialog>
  <ShareDialog
    :shareId="skillInfo.userUuid"
    v-model="showShareDialog"
  />

</div>
</template>
<script>
import { mapGetters } from 'vuex'
import PhotoList from '@/components/PhotoList'
import InputNumber from '@/components/InputNumber';
import TipBtn from './TipBtn'
import ScoreExplain from '@/components/ScoreExplain'
import ShareDialog from '@/components/FpsShare/index'
import LineControl from '@/components/common/text/line-control'
export default {
  components: {
    PhotoList,
    InputNumber,
    TipBtn,
    ScoreExplain,
    ShareDialog,
    LineControl
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    info: { // 当前展示技能信息
      type: Object,
      default: () => ({}),
    },
    quickMatchUuid: {
      type: String,
      default: '',
    },
    master: { // 陪陪个人信息
      tpye: Object,
      default: null,
    },
    masterDialog: { // 是否在个人详情页
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      skillInfo: {},
      masterInfo: {},
      selectedModel: {},
      orderCount: 1,
      swipeIndex: 0,
      commentCateList: [],
      commentList: [],
      selectedCommentCateId: '',
      commentFinshed: false,
      gettingComment: false,
      commentTotal: 0,
      rankSlideIndex: 0,
      scorePopupStatus: false,
      scorePopupType: 'ScoreCExplain',
      showBackTop: false,
      showBottomOrder: false,
      showShareDialog: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'viewMasterInfo', 'loadingViewMasterInfo', 'adminUuid']),
    isSelf() {
      return this.userInfo && this.userInfo.uuid === this.skillInfo.userUuid
    },
    isAdmin() {
      return this.skillInfo.userUuid == this.adminUuid
    },
    isOnline() {
      return this.$util.isOnline(this.skillInfo)
    },
    labelList() {
      return this.$util.computedTags((this.skillInfo.labelList || [])).concat(this.$util.computedTags(this.skillInfo.labelList || [], 'comment').slice(0, 2))
    },
    showLolTag() {
      if (!this.skillInfo.labelList) return false
      return this.skillInfo.labelList.some(item => item.labelId > 1000 && item.labelId < 10000)
    },
    newComerCouponList() {
      if (!this.accountInfo) return []
      return (this.accountInfo.couponInfoList || []).filter(
        (item) => {
          return item.couponTemplate == 'NEWCOMER_EXPERIENCE' && item.couponStatus === 'EFFECT';
        }
      )
    },
    userOrder() {
      const defaultData = { star: 0, starOrder: 0, order: 0 }
      if (!this.viewMasterInfo.uuid) return defaultData
      return this.viewMasterInfo.playerSkillVoList.reduce((rs, item) => {
        rs.star += item.starRating * item.countComment
        rs.starOrder += item.countComment
        rs.order += item.countTransactions
        return rs
      }, defaultData)
    },
    screenshotImageUrlList() {
      if (this.skillInfo.screenshotImageUrlList) {
        return JSON.parse(this.skillInfo.screenshotImageUrlList)
      } else if (this.skillInfo.screenshotImageUrl) {
        return [this.skillInfo.screenshotImageUrl]
      } else return []
    },
    discountList() {
      const list = []
      if (!this.userInfo) {
        this.newDiscountList(list)
        list.push(`新人優惠券減${ this.$util.newerDiscount }`)
      } else if (this.newComerCouponList[0]) {
        this.newDiscountList(list)
        list.push(`新人優惠券減${ this.newComerCouponList[0].couponAmount }`)
      } else if (this.skillInfo.firstOrderPrivilege && this.selectedModel.id === 0) {
        list.push('首單優惠')
      }
      return list
    },
    rankListActive() {
      if (this.masterDialog || !this.viewMasterInfo.playerSkillVoList) return null
      const otherSkills = this.viewMasterInfo.playerSkillVoList.filter(item => item.id !== this.skillInfo.id)
      if (!otherSkills.length) return null
      const length = 5
      const len = otherSkills.length % length
      len && otherSkills.splice(otherSkills.length, 0, ...new Array(length - len).fill(''))
      const rs = []
      while (otherSkills.length) {
        rs.push(otherSkills.splice(0, length))
      }
      return rs
    },
  },
  watch: {
    show(show) {
      this.showDialog = show
      if (show) {
        this.getDefaultData()
        this.reportVisitor()
      }
      this.lockScroll()
    },
    showDialog(show) {
      this.$emit('change', show)
    },
    info() {
      this.getDefaultData()
    },
    skillInfo(info) {
      if (info) {
        if (!info.id && info.skillId) {
          this.$set(this.skillInfo, 'id', info.skillId)
          return
        }
        if (!info.userUuid && info.uuid) {
          this.$set(this.skillInfo, 'userUuid', info.uuid)
          return
        }
        this.setDefaultPrice()
        this.reportVisitor()
      }
    },
    $route () {
      this.showParams()
    },
  },
  created() {
    this.showDialog = this.show
    this.getDefaultData()
    this.reportVisitor()
  },
  mounted() {
    this.lockScroll()
  },
  beforeDestroy() {
    window.document.body.style.overflow = 'auto'
  },
  methods: {
    showParams() {
      const historyKey = window.history.state.key
      if (!this.showDialog && this.historyObjList) {
        const index = this.historyObjList.findIndex(item => item.historyKey === historyKey)
        if (index === -1) return
        const [historyObj] = this.historyObjList.splice(index, 1)
        if (historyObj.masterInfo.uuid !== this.viewMasterInfo.uuid) {
          this.$store.dispatch('app/setViewMasterInfo', historyObj.viewMasterInfo)
          this.skillInfo = historyObj.skillInfo
        }
        this.showDialog = true
      }
    },
    saveHistoryKey() {
      if (this.$route.name === 'Chat') return
      const historyKey = window.history.state.key
      const historyObj = {
        historyKey,
        masterInfo: this.viewMasterInfo,
        skillInfo: this.skillInfo,
      }
      if (!this.historyObjList) {
        this.historyObjList = [historyObj]
      } else {
        this.historyObjList.push(historyObj)
      }
      this.showDialog = false
    },
    borderMethod(d) {
      if (d === 0) {
        return 3 + (this.viewMasterInfo.strongest.guardLevel || 1)
      } else if (d === -1) {
        return 3
      } else if (d) {
        return 2
      } else {
        return 0
      }
    },
    lockScroll() {
      if (this.showDialog) {
        window.document.body.style.overflow = 'hidden'
      } else {
        window.document.body.style.overflow = 'auto'
      }
    },
    detailScroll() {
      const time = Date.now()
      if (!this.lastTimer || time - this.lastTimer > 200) {
        // 节流
        this.lastTimer = time
        this.pageScrollFn()
        // 防抖
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.timer = null
          this.pageScrollFn()
        }, 400)
      }
    },
    pageScrollFn() {
      const buttonBottom = this.$refs.tool_button_bottom
      const pageTop = this.$refs.page_top
      if (buttonBottom) {
        const { y, height } = buttonBottom.getBoundingClientRect()
        if (y + height > 0) {
          if (this.showBottomOrder) this.showBottomOrder = false
        } else if (!this.showBottomOrder) this.showBottomOrder = true
      }
      if (pageTop) {
        const { y } = pageTop.getBoundingClientRect()
        if (y < - window.screen.height * 0.5) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }
      }
    },
    backTop() {
      this.$refs.page_top.scrollIntoView({
        behavior: 'smooth',
      })
    },
    openScorePopup() {
      let userKind = this.viewMasterInfo && this.viewMasterInfo.userKind;
      // 如果是自己并且查看的是b端用户
      if (this.isSelf && userKind === 'Player') {
        this.scorePopupType = 'ScoreBExplain';
      } else {
        this.scorePopupType = 'ScoreCExplain';
      }
      this.scorePopupStatus = true;
    },
    // 切换轮播
    swipeChange(method, refName) {
      const $swipe = this.$refs[refName]
      if (!$swipe) return
      $swipe[method]()
    },
    changeSwipe(swipeIndex) {
      this.swipeIndex = swipeIndex
    },
    newDiscountList(list) {
      if (this.selectedModel.id === 0 && this.skillInfo.redBagFreeFlag && this.skillInfo.selfSpreadDiscount) {
        list.push(`新人${this.skillInfo.selfSpreadDiscount * 10}折`)
      }
    },
    selectPrice(model) {
      model ? (this.selectedModel = model) : this.setDefaultPrice()
    },
    setDefaultPrice() {
      this.selectedModel = {
        id: 0,
        name: '標準模式',
        price: this.skillInfo.price,
        showPrice: this.$util.computedPrice(this.skillInfo) !== '' ? this.$util.computedPrice(this.skillInfo) : this.skillInfo.salesPrice,
        salesUnit: this.skillInfo.salesUnit,
      }
    },
    getDefaultData() {
      if (!this.show && !this.info.userUuid) return
      this.setDefaultPrice()
      this.swipeIndex = 0
      if (!this.master) {
        this.info.noReport = true // 取消上报
        this.skillInfo = this.info
        if (this.skillInfo.userUuid !== this.viewMasterInfo.uuid) {
          this.getMasterInfo()
        } else {
          this.getSkillInfo()
        }
      } else {
        this.getSkillInfo()
      }
      this.getDefaultComment()
    },
    getDefaultComment() {
      this.commentCateList = []
      this.commentList = []
      this.selectedCommentCateId = ''
      this.commentFinshed = false
      this.gettingComment = false
      this.lastItemId = ''
      this.commentTotal = 0
      this.notFirst = false
      this.getCommentList()
    },
    changeSkill(skill) {
      this.skillInfo = skill
      this.getDefaultComment()
      this.backTop()
    },
    getCommentList() {
      if (this.commentFinshed && this.gettingComment) return
      this.gettingComment = true
      const offset = this.notFirst ? 10 : 6
      const playerSkillId = this.skillInfo.id
      this.$http.get('comment/list', {
        lastItemId: this.lastItemId,
        offset,
        playerUserUuid: this.skillInfo.userUuid,
        playerSkillId,
      }).then(({ data })=> {
        if (playerSkillId !== this.skillInfo.id) return
        if (!this.notFirst) {
          this.commentCateList = data.tagStatic
          this.commentTotal = data.totalRemain
          this.notFirst = true
        }
        if (data.pageContent.length) {
          this.commentList = this.commentList.concat(data.pageContent)
          this.lastItemId = data.pageContent[data.pageContent.length - 1].id
        }
        if (data.pageContent.length < offset || this.commentTotal === this.commentList.length) {
          this.commentFinshed = true
        }
        this.gettingComment = false
      }).catch(() => {
        if (playerSkillId !== this.skillInfo.id) return
        this.gettingComment = false
      })
    },
    reportVisitor() {
      if (!this.show || this.skillInfo.noReport) return
      // C端查看B端技能上報
      this.$http.post('/visit/report/skill', {
        gameName: this.skillInfo.gameName,
        reportedUuid: this.skillInfo.userUuid,
      });
      this.$adjust('web_check_skill', {
        player_uuid: this.skillInfo.userUuid,
        skill_id: this.skillInfo.id,
        game_id: this.skillInfo.gameId,
      })
    },
    openChat() {
      if (this.quickMatchUuid) return
      if (this.userInfo) {
        this.$util.openChatWindow(this.userInfo.uuid, this.skillInfo.userUuid, this.skillInfo.id)
      } else {
        this.$util.Login()
      }
    },
    openOrderPage() {
      if (this.quickMatchUuid) return
      const {
        quickMatchUuid,
        orderCount,
        skillInfo,
        selectedModel: { id: modelId },
      } = this;
      // 極速約單的訂單
      if (quickMatchUuid) {
        this.saveHistoryKey()
        this.$router.push({
          path: `/order/check/${skillInfo.id}/${orderCount}`,
          query: {
            quickMatchUuid,
            price: modelId || ''
          }
        })
        return;
      }

      if (!skillInfo || !skillInfo.id)
        return this.$message.erroror('請選擇下單技能');

      if (orderCount > 15)
        return this.$message.error('下單數量不能超過15');
      if (orderCount < 1)
        return this.$message.error('下單數量不能少於1');
      window.fbq('track', 'AddToCart');

      if (this.userInfo) {
        this.saveHistoryKey()
        this.$router.push({
          path: `/order/check/${skillInfo.id}/${orderCount}`,
          query: {
            quickMatchUuid,
            price: modelId || ''
          }
        })
      } else {
        this.$util.Login({
          isClickOrder: true
        }).then((params) => {
          if (
            params.isLogin &&
            this.userInfo &&
            this.userInfo.phoneNumber &&
            this.userInfo.phoneNumber.substring(0, 3) !== '886' &&
            this.skillInfo.redBagFreeFlag
          ) {
            this.$message({
              message: '很遺憾，目前新人優惠券只支持台灣地區的手機號',
            });
            return;
          } else if (
            params.isLogin &&
            this.userInfo &&
            !this.userInfo.hasRedBag &&
            this.skillInfo.redBagFreeFlag
          ) {
            this.$message({
              message: '每個用戶註冊後只有一次使用新人優惠券機會喔',
            });
            return;
          }
          if (!this.isSelf) {
            this.getMasterMusk();
          }
        });
      }
    },
    getMasterMusk() {
      this.$http.get('/user/chart/guide').then(({ data }) => {
        this.masterMusk = data;
      });
    },
    async getMasterInfo() {
      if (this.info.userUuid !== this.viewMasterInfo.uuid) {
        await this.$store.dispatch('app/getMasterInfo', { uuid: this.skillInfo.userUuid })
      }
      this.getSkillInfo()
    },
    getSkillInfo() {
      if (!this.viewMasterInfo.playerSkillVoList || !this.viewMasterInfo.playerSkillVoList.length) return
      this.skillInfo = this.viewMasterInfo.playerSkillVoList.find(item => item.id === this.info.id) || this.info
    },
    openMasterDetail(userUuid) {
      if (this.quickMatchUuid) return
      this.saveHistoryKey()
      this.$router.push({
        path: `/player-detail/${ userUuid || this.skillInfo.userUuid }`,
        query: {
          isHome: this.$route.query.isHome,
        }
      })
    },
    editReply(index) {
      if (this.lastCommentIndex !== undefined) {
        const lastComment = this.commentList[this.lastCommentIndex]
        lastComment.replying = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      }
      const nextComment = this.commentList[index]
      nextComment.replying = true
      this.commentList.splice(this.index, 1, nextComment)
      this.lastCommentIndex = index
    },
    cancelReply() {
      if (this.lastCommentIndex !== undefined) {
        const lastComment = this.commentList[this.lastCommentIndex]
        lastComment.replying = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
        this.lastCommentIndex = undefined
      }
    },
    finshReply() {
      const { lastCommentIndex } = this
      if (lastCommentIndex === undefined) return
      const lastComment = this.commentList[this.lastCommentIndex]
      lastComment.replyLoading = true
      this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      this.$http.post('/comment/player/writeReply', {
        orderCommentId: lastComment.reply.orderCommentId,
        content: lastComment.replyContent,
      }).then(() => {
        lastComment.replyLoading = false
        lastComment.replying = false
        lastComment.reply.content = lastComment.replyContent
        lastComment.reply.status = 'HadReply'
        lastComment.createTime = Date.now()
        this.lastCommentIndex = undefined
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      }).catch(({ msg }) => {
        lastComment.replyLoading = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
        this.$message.error(msg)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .visible-arrow {
    opacity: 1 !important;
  }
  .custom-swiper-banner {
    margin-top: 24px;
  }
  .score-btn {
    @include flex;
    &:hover {
      cursor: pointer;
      span {
        color: $color-link !important;
        text-decoration: underline;
      }
    }
  }
  .loading-container {
    @include flex;
    font-size: 20px;
    margin-top: 20px;
  }
  .label-text {
    padding: 16px 0 25px 24px;
    .title {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: $color-gray-1;
      text-align: left;
    }
    ul {
      margin-top: 12px;
      li {
        @include flex(flex-start);
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-2;
        &:not(:first-child) {
          margin-top: 8px;
        }
        .tag-wrap {
          font-size: 12px;
          line-height: 16px;
          &::before{
            width: 16px;
            height: 16px;
          }
          margin-right: 6px;
        }
      }
    }
  }
  .dialog-clear-style-wrap {
    & /deep/ .dialog-clear-style {
      max-width: 100vw;
      width: 100vw;
    }
  }
  .scroll-wrap {
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    background: rgba(0, 0, 0, .7);
    // width: 100vw;
    // height: 100vh;
    // position: relative;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .page-top {
      width: 100%;
      height: 1px;
      margin-bottom: 23px;
    }
    .back-top {
      position: fixed;
      left: 50%;
      bottom: 48px;
      transform: translate(440px);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, .2);
      @include flex;
      cursor: pointer;
    }
    .close-skill-detail {
      position: fixed;
      top: 32px;
      right: 32px;
    }
    .skill-slide {
      position: fixed;
      top: 32px;
      left: 50%;
      transform: translateX(440px);
      @include flex(flex-start, center, column);
      .user-image {
        width: 40px !important;
        height: 40px !important;
        margin-bottom: 16px;
        // border: 2px solid #fff;
      }
      .im-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(255, 255, 255, .2);
        margin-bottom: 16px;
        @include flex;
      }
    }
  }
  .order-bottom {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 816px;
    transition: all .3s ease-in-out;
    z-index: 20;
    height: 97px;
    border-top: 1px solid $color-split;
    background: #fff;
    @include flex(space-between);
    padding: 0 32px;
    .price-wrap {
      color: $color-price;
      @include flex(flex-start, flex-end);
      .sale-price {
        font-weight: 600;
        font-size: 24px;
        line-height: 34px;
        margin-right: 2px;
      }
      .sale-unit {
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        margin-left: 2px;
      }
      .old-price {
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        margin-left: 8px;
        text-decoration-line: line-through;
        color: $color-gray-3;
      }
    }
    .tool-buttons {
      margin-top: 0;
    }
  }
  .skill-detail-dialog {
    width: 816px;
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #EFEFEF;
    position: relative;
    padding: 0 32px 144px;
  }
  .skill-detail-title {
    @include flex(flex-start);
    font-size: 12px;
    line-height: 16px;
    color: $color-gray-2;
    margin-bottom: 24px;
    .user-image {
      width: 32px !important;
      height: 32px !important;
    }
    .nickname {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      margin-left: 8px;
    }
    .is-admin {
      margin-left: 8px;
    }
    .userlevel-tag {
      transform: scale(0.8);
      margin-left: -6px;
    }
    .online-circle-wrap {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $color-offline;
      margin-left: 18px;
      &.is-online-wrap {
        background: $color-green;
      }
    }
    .online-text {
      margin-left: 2px;
    }
    .reply-count {
      margin-left: 16px;
    }
  }
  .detail-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    color: $color-gray-1;
    margin-top: 48px;
  }
  .skill-top {
    @include flex(flex-start, flex-start);
    .game-image {
      width: 164px;
      border-radius: 4px;
    }
    .skill-info {
      margin-left: 32px;
    }
  }
  .skill-info {
    .skill-name {
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: $color-gray-1;
    }
    .order-state {
      @include flex(flex-start);
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-2;
      margin-top: 4px;
      .order-count {
        @include flex(flex-start);
      }
      .stronger {
        font-weight: 500;
        margin: 0 2px;
      }
      .line {
        width: 1px;
        height: 12px;
        background: $color-split;
        margin: 0 16px;
      }
      .order-score {
        margin-left: 8px;
        @include flex;
        span {
          margin-left: 2px;
        }
      }
    }
    .display-price {
      margin-top: 32px;
      .price {
        @include flex(flex-start, flex-end);
        .sale-price {
          font-weight: 600;
          font-size: 24px;
          line-height: 34px;
          color: $color-price;
          margin-right: 2px;
        }
        .sale-unit {
          font-weight: 500;
          font-size: 12px;
          line-height: 24px;
          color: $color-price;
          margin-left: 2px;
        }
        .old-price {
          font-weight: 500;
          font-size: 12px;
          line-height: 24px;
          margin-left: 8px;
          text-decoration-line: line-through;
          color: $color-gray-3;
        }
      }
      .price-onecoin {
        flex-shrink: 0;
        @include flex(flex-start);
        width: 100%;
        margin-top: 6px;
        div {
          @include flex;
          position: relative;
          overflow: hidden;
          height: 18px;
          line-height: 18px;
          padding: 0 4px 0 52px;
          color: $color-orange;
          font-size: 12px;
          border: 1PX solid $color-orange;
          border-radius: 2px;
          span {
            @include flex;
            position: absolute;
            left: -2px;
            top: 50%;
            transform: translateY(-50%);
            width: 50px;
            height: 36px;
            background: $color-orange;
            color: #fff!important;
            font-size: 12px!important;
            font-weight: 800;
          }
        }
      }
      .discount-list {
        @include flex(flex-start);
        margin-top: 6px;
        height: 20px;
        .one-discount {
          padding: 2px 8px;
          height: 100%;
          @include flex;
          font-size: 12px;
          line-height: 1;
          color: #FF6610;
          background: rgba(254, 127, 56, 0.15);
          border-radius: 34px;
        }
      }
    }
    .tool-button-bottom {
      width: 100%;
      height: 1px;
    }
    .discount-price {
      height: 16px;
    }
    .select-wrap {
      @include flex(flex-start, flex-start);
      line-height: 22px;
      &:not(:first-child) {
        margin-top: 20px;
      }
      &.select-price {
        line-height: 28px;
        margin-top: 28px;
        .select-left {
          margin-top: 8px;
        }
      }
      &.give-away {
        line-height: 18px;
      }
      .select-left {
        width: 72px;
        font-size: 14px;
        color: $color-gray-2;
        text-align: left;
      }
      .select-right {
        @include flex(flex-start, flex-start);
        flex-wrap: wrap;
        width: 344px;
      }
      .model-price {
        padding: 0 8px;
        height: 28px;
        border: 1px solid #E8EAEE;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        color: $color-gray-2;
        cursor: pointer;
        @include flex;
        margin: 8px 8px 0 0;
        &.selected {
          background: #FFFBF9;
          border: 1px solid #E49F78;
          font-weight: 500;
          color: $color-gray-1;
        }
        .model-name {
          margin-right: 8px;
        }
      }
      .one-give-away {
        font-size: 12px;
        height: 18px;
        padding: 0 4px;
        border-radius: 4px;
        color: #EA320A;
        border: 1px solid #FFEAE6;
        &:not(:first-child) {
          margin-left: 6px;
        }
      }
    }
  }
  .tool-buttons {
    @include flex(flex-start);
    margin-top: 64px;
    button {
      width: 160px;
      height: 48px;
      font-weight: 500;
      font-size: 16px;
      color: $color-gray-1;
      border-radius: 50px;
      @include flex;
    }
    .chat-btn {
      margin-right: 16px;
      @include button-yellow;
      &-text {
        margin-left: 10px;
      }
    }
    .order-btn {
      @include button-yellow;
    }
  }
  .skill-description {
    .skill-voice {
      width: 200px;
      height: 40px;
      margin-top: 16px;
    }
    .skill-description-tags {
      margin-top: 16px;
      @include flex(space-between);
      .tags-list {
        @include flex(flex-start);
        & > div {
          height: 24px !important;
          &::before {
            width: 20px;
            height: 20px;
          }
          &:not(:first-child) {
            margin-left: 8px;
          }
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: $color-split;
      margin: 24px 0;
    }
    .skill-attr {
      margin-bottom: 8px;
      @include flex(flex-start);
      font-size: 14px;
      line-height: 20px;
      &-name {
        width: 96px;
        text-align: left;
        color: $color-gray-2;
      }
      &-value {
        color: $color-gray-1;
      }
    }
    .pubg-kda {
      margin-top: 8px;
      @include flex(flex-start);
      .nicee-certification {
        height: 16px;
        margin-right: 6px;
      }
      span {
        color: $color-gray-2;
        margin-right: 20px;
      }
    }
  }
  .master-info {
    .master-info-wrap {
      margin-top: 16px;
      display: flex;
      padding: 24px;
      background: #F9F9F9;
      border: 1px solid $color-button;
      border-radius: 4px;
      .line {
        height: 64px;
        width: 1px;
        background: $color-split;
      }
      &-left {
        flex: 1;
        @include flex(flex-start);
        .user-avatar {
          width: 64px;
          height: 64px;
          position: relative;
          margin-right: 15px;
          .online-state {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 0;
            bottom: 0;
            border: 2px solid #fff;
            border-radius: 50%;
            background: $color-offline;
            &.is-online-wrap {
              background: $color-green;
            }
          }
        }
        &-other {
          @include flex(center, flex-start, column);
          .user-nickname {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: $color-gray-1;
          }
          .tool-btns {
            @include flex(flex-start);
            margin-top: 8px;
            button {
              width: 88px;
              height: 28px;
              @include flex;
              font-size: 12px;
              box-sizing: border-box;
              border-radius: 50px;
              span {
                margin-left: 6px;
              }
              @include button-gray-2;
              color: $color-gray-2;
              border: 1px solid #636D86;
            }
            .chat-btn {
              margin-right: 8px;
            }
          }
        }
      }
      &-right {
        flex: 1;
        padding-left: 48px;
        @include flex(flex-start);
        .data-wrap-name {
          font-size: 14px;
          line-height: 20px;
          color: $color-gray-1;
          margin-right: 8px;
          text-align: left;
          &>div {
            height: 20px;
          }
          &>div:not(:first-child) {
            margin-top: 8px;
          }
        }
        .data-wrap-value {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: $color-price;
          text-align: left;
          &>div {
            height: 20px;
          }
          &>div:not(:first-child) {
            margin-top: 8px;
          }
          &:not(:last-child) {
            width: 100px;
          }
        }
        .loading-wrap .data-wrap-value {
          color: $color-gray-3;
        }
      }
    }
  }
  .comment-list {
    .detail-title {
      @include flex(space-between);
      .star-count {
        @include flex;
        span {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: $color-gray-2;
          margin-right: 8px;
        }
      }
    }
    .comment-cate {
      @include flex(flex-start, flex-start);
      flex-wrap: wrap;
      margin-top: 6px;
      .one-comment-cate {
        margin: 10px 8px 0 0;
        padding: 3.5px 10px;
        border: 1px solid rgba(140, 148, 170, 0.3);
        border-radius: 50px;
        font-size: 12px;
        line-height: 17px;
        color: $color-gray-2;
        cursor: default;
        @include flex;
        span {
          margin-left: 6px; 
        }
        &.selected {
          border-color: $color-link;
          background: rgba(0, 122, 255, 0.1);
          color: $color-link;
        }
      }
    }
    &-wrap {
      display: flex;
      flex-direction: column;
      margin-top: 12px;
      .one-comment {
        margin-top: 12px;
        padding: 16px 0;
        @include flex(flex-start, flex-start);
        position: relative;
        $comment-first: 50px;
        .comment-star {
          position: absolute;
          top: $comment-first / 2;
          right: 0;
          transform: translateY(-50%);
        }
        .comment-avatar {
          width: $comment-first;
          height: $comment-first;
          margin-right: 16px;
          cursor: pointer;
        }
        .info-wrap {
          @include flex(flex-start, flex-start, column);
          flex: 1;
          .nickname {
            @include flex(flex-start);
            overflow: hidden;
            font-weight: 500;
            font-size: 14px;
            height: 20px;
            color: $color-gray-1;
            .is-admin {
              margin-left: 3px;
            }
            .userlevel-tag {
              transform: scale(0.7);
              margin-left: -16px;
            }
          }
          .comment-time {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: rgba(99, 109, 134, 0.5);
            margin-top: 2px;
          }
          .comment-content {
            width: 100%;
            margin-top: 16px;
            font-size: 14px;
            line-height: 22px;
            color: $color-gray-2;
            position: relative;
            .good-comment {
              position: absolute;
              width: 30px;
              right: 0;
              top: -20px;
            }
          }
          .tags-list-wrap {
            @include flex;
            margin-top: 8px;
            padding: 3.5px 8px;
            background: $color-button;
            border-radius: 50px;
            font-size: 12px;
            line-height: 17px;
            letter-spacing: -0.000319808px;
            color: $color-gray-3;
          }
          .reply-btn {
            margin-top: 8px;
            align-self: flex-end;
            font-size: 12px;
            line-height: 16px;
            color: $color-gray-1;
            @include flex;
            cursor: pointer;
            & > i {
              margin-right: 5px;
            }
          }
          .replying-wrap {
            margin-top: 16px;
            background: rgba($color: $color-gray-3, $alpha: .1);
            border-radius: 4px;
            padding: 16px;
            width: 100%;
            @include flex(flex-start, flex-start, column);
            .master-reply {
              @include flex;
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              color: $color-gray-2;
              .nickname {
                margin-right: 4px;
                color: $color-gray-1;
              }
            }
            .replyed-content {
              margin-top: 4px;
              font-size: 14px;
              line-height: 22px;
              color: $color-gray-2;
            }
            .reply-content {
              margin-top: 8px;
              background: #FFFFFF;
              border: 1px solid $color-split;
              border-radius: 4px;
              padding: 12px 20px 0 12px;
              font-size: 14px;
              line-height: 22px;
              color: $color-gray-2;
              width: 100%;
              height: 90px;
              resize: none;
            }
            .reply-btns {
              align-self: flex-end;
              margin-top: 8px;
              @include flex;
              button {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
              }
              .cancel-btn {
                color: $color-gray-3;
              }
              .confirm-btn {
                color: $color-link;
                margin-left: 16px;
                &:disabled {
                  background: transparent !important;
                  opacity: .3;
                  color: $color-link !important;
                }
              }
            }
          }
        }
      }
      .no-more-comment,
      .get-more-comment {
        margin: 24px auto 0;
        width: 116px;
        height: 36px;
        @include flex;
        text-align: center;
        border-radius: 50px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.000319808px;
        color: $color-gray-2;
      }
      .no-more-comment {
        color: $color-gray-3;
      }
      .get-more-comment {
        border: 1px solid $color-split;
      }
    }
    .comment-empty {
      @include flex(flex-start, center, column);
      margin-top: 34px;
      &-img {
        width: 140px;
      }
      &-text {
        margin-top: 15px;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-2;
      }
    }
  }
  .other-skill {

    .custom-swiper {
      width: 100%;
      margin-top: 16px;
      height: 136px;
      margin-bottom: 54px;
      .banner-logined {
        position: relative;
        overflow: hidden;
        height: 190px;
        margin-top: 16px;
        z-index: 0;
        border-radius: 4px;
      }
      // img {
      //   position: absolute;
      //   left: 50%;
      //   top: 50%;
      //   transform: translate(-50%, -50%);
      //   width: auto;
      //   height: 100%;
      // }
      .ranks-slide-card {
        @include flex(space-between);
      }
      .one-game {
        width: 136px;
        height: 190px;
        & > div {
          width: 100%;
          height: 100%;
          @include flex(flex-start, center, column);
          .game-image {
            width: 100%;
            border-radius: 4px;
          }
          .game-name {
            margin-top: 8px;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: -0.3px;
            color: $color-gray-1;
          }
          .sale-price {
            margin-top: 4px;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: $color-price;
          }
        }
      }
    }
  }
.desc-context {
  margin:16px 0 24px;
  font-size: 14px;
  line-height: 22px;
  color: #636d86;
}
.wrap-text {
  height: 100%;
  /deep/ .el-textarea__inner {
    background-color: white !important;
    border: none;
    padding: 0;
    font-style: normal;
    font-size: 14px;
    line-height: 21px;
    color: #636d86;
    cursor: unset;
  }
}
</style>
